/* eslint-disable import/prefer-default-export */
// import/prefer-default-export: change when this has additional functions
// change will break some tests

const JSLoader = {
  queue: [],
  loadJs: (clonedScript, onl) => {
    const s = document.createElement('script');
    // Copy all the attributes from the original script
    for (let j = 0; j < clonedScript.attributes.length; j++) {
      const a = clonedScript.attributes[j];
      s.setAttribute(a.name, a.value);
    }
    s.appendChild(document.createTextNode(clonedScript.innerHTML));
    if (s.src) {
      // onload event which will be called once the src
      // request is completed (success or failure)
      s.onload = () => { onl(); };
      s.onerror = () => { onl(); };
    }

    // replace the element
    clonedScript.parentNode.replaceChild(s, clonedScript);

    if (!s.src) {
      // fire the onload callback now since there is no src
      // and the onload event will not be fired by the browser
      onl();
    }
  },
  add: (data) => {
    // add all the scripts to the queue
    for (let i = data.src.length - 1; i >= 0; i--) {
      const dataCopy = data;
      JSLoader.queue.splice(0, 1, {
        src: data.src[i],
        onload: () => {
          if (JSLoader.hasNext() === false) {
            if (dataCopy.onload) {
              // call the final onload if set
              dataCopy.onload();
            }
          } else {
            // load the next queued script
            JSLoader.next();
          }
        },
      }, JSLoader.queue[0]);
    }
    JSLoader.next();
  },
  hasNext: () => {
    // is there a next script in the queue
    if (JSLoader.queue.length !== 0 && JSLoader.queue[0]) {
      return true;
    }
    return false;
  },
  next: () => {
    if (JSLoader.queue.length !== 0 && JSLoader.queue[0]) {
      const scr = JSLoader.queue[0];

      // Remove the script from the queue
      if (JSLoader.queue.length > 1) {
        JSLoader.queue.splice(0, 2, JSLoader.queue[1]);
      } else {
        JSLoader.queue = [];
      }

      // Load the script
      JSLoader.loadJs(scr.src, scr.onload);
    } else {
      return false;
    }
    return false;
  },
};

const setInnerHtml = (elm, html) => {
  elm.innerHTML = html;
  const scripts = elm.getElementsByTagName('script');
  // If we don't clone the results then "scripts"
  // will actually update live as we insert the new
  // tags, and we'll get caught in an endless loop
  const scriptsClone = [];
  for (let i = 0; i < scripts.length; i++) {
    scriptsClone.push(scripts[i]);
  }
  JSLoader.add({
    src: scriptsClone,
    onload: () => {},
  });
};

// Duplicates behavior of jquery element serializeArray()
// https://plainjs.com/javascript/ajax/serialize-form-data-into-an-array-46/
const serializeArray = (form) => {
  // Strips values from form and will packages them in an array as objects.
  // [{..},{..},{..}]
  // Tested for input (text, radio, checkbox), select, multi-select, textarea elements
  let field = [];
  let l = [];
  const s = [];
  if (typeof form === 'object') {
    const len = form.elements.length;
    for (let i = 0; i < len; i++) {
      field = form.elements[i];
      if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button') {
        if (field.type === 'select-multiple') {
          l = form.elements[i].options.length;
          for (let j = 0; j < l; j++) {
            if (field.options[j].selected) {
              s[s.length] = { name: field.name, value: field.options[j].value };
            }
          }
        } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
          s[s.length] = { name: field.name, value: field.value };
        }
      } else if (field.type === 'file') {
        // https://www.taniarascia.com/how-to-upload-files-to-a-server-with-plain-javascript-and-php/
        // assumes only one file
        // only does this for a multipart data form due to how form-ajax is used
        if (form.getAttribute('enctype') === 'multipart/form-data') {
          if (field.files.length === 1) {
            s[s.length] = { name: field.name, value: field.files[0] }
          }
        }
      }
    }
  }
  return s;
};

const sharedFunctions = {
  JSLoader,
  serializeArray,
  setInnerHtml,
};

export default sharedFunctions;
